import React, { useEffect, useState } from "react";
import SalesPerDayMonthGraph from "../../components/VentasDatos/SalesPerDayMonthGraph";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function SalesPerDayMonth() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      const user = getUser();

      try {
        const res = await fetch(`${URL}/api/sales/datos/summary/month-daily-sales/`, {
          headers: {
            "Content-Type": "application/json",
            "x-empresa-id": user?.empresa_id
          },
        });
        if (!res.ok) {
          throw new Error("Error al obtener los datos");
        }
        const json = await res.json();
        setData(json);
      } catch (err) {
        setError("No se pudo obtener los datos");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ mt: 4, textAlign: "center" }}>
        {error}
      </Typography>
    );
  }

  return <SalesPerDayMonthGraph data={data} />;
}